<template>
  <div
    class="rounded-full w-9 h-9 relative text-[10px] -indent-[9999em] my-6 mx-auto border-4 border-primary border-b-dark-400 animate-spin after:rounded-full after:w-9 after:h-9"
  ></div>
</template>
